/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Degraded_Budget_ExhaustedInputs */



/**
* | output |
* | --- |
* | "The last sync stopped when this connection used up its request budget for the hour. Nothing failed — the next sync continues where it left off." |
*
* @param {Sync_Degraded_Budget_ExhaustedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sync_degraded_budget_exhausted = /** @type {((inputs?: Sync_Degraded_Budget_ExhaustedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Degraded_Budget_ExhaustedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die letzte Synchronisierung endete, als diese Verbindung ihr Anfragebudget für die Stunde aufgebraucht hatte. Es ist nichts fehlgeschlagen — die nächste Synchronisierung macht dort weiter.")
	return /** @type {LocalizedString} */ ("The last sync stopped when this connection used up its request budget for the hour. Nothing failed — the next sync continues where it left off.")
});